module.exports = __webpack_public_path__ + "img/ChairToolkit.e0be50ae.svg";